<!--
 * @Author: your name
 * @Date: 2021-07-14 17:19:09
 * @LastEditTime: 2021-07-15 14:53:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \SurgicalCommunication\src\components\disclaimer.vue
-->
<template>
  <div class="disclaimer">
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import { Checkbox, } from "view-design"
export default {
    components:{
      Checkbox,
      pdf,
    },
    data(){
      return {
        isagreen:false,
      }
    },
    methods:{
      change(e){
        // console.log(e)
        this.$emit("value",e)
      },
    },
    created(){
      
    },
    mounted(){

    },
}
</script>

<style lang="less">
  .disclaimer{
      user-select:none;
      .ivu-checkbox{
        margin-right: 7px;
      }
    .ivu-checkbox-inner{
      border-radius: 50%;
    }
    .ivu-checkbox-checked .ivu-checkbox-inner:after{
          border: 1px solid #17233d;
          border-top: 0;
          border-left: 0;
    }
    .ivu-checkbox-checked .ivu-checkbox-inner{
          border-color: #dcdee2;
          background-color: transparent;
    }
  }
</style>